import {
  Button,
  Card,
  Col,
  Flex,
  Form,
  Input,
  Modal,
  Rate,
  Row,
  Select,
  Typography,
} from "antd";
import React, { useCallback } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TextArea from "antd/es/input/TextArea";
import { useEffect } from "react";
import { CustomTitle } from "../../../../../common/customTitle";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import { sanitizeDataTypeClientSide } from "../../../../../../utils/utils";
import { getFaqByIdAction } from "../../../../../../redux/services/faqs/faqsServices";
import Actions from "../../../../../../redux/actions";
import {
  addSuperAdminReviewAction,
  getReviewByIdAction,
} from "../../../../../../redux/services/reviews/reviewsServices";
import { colors } from "../../../../../../constants/colors";
import Spinner from "../../../../../common/spinner/Spinner";
import { appConstConfig } from "../../../../../../constants/config/appConstConfig";

const ReviewInfoDialog = ({ open, onClose }) => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* form dependencies */
  const [form] = Form.useForm();
  /* form dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [selectListLoader, setSelectListLoader] = useState(false);
  /* loading dependencies */

  /* id dependencies */
  const [reviewDetails, setReviewDetails] = useState(null);
  const { selectedReviewId } = useSelector((state) => state.reviews);
  /* id dependencies */

  useEffect(() => {
    handleGetData();
  }, [open]);

  const handleGetData = () => {
    /* initial dependencies - Edit */
    if (
      selectedReviewId &&
      selectedReviewId !== "" &&
      selectedReviewId !== null &&
      selectedReviewId !== undefined
    ) {
      const dataToBeSent = {
        selectedReviewId,
      };
      dispatch(getReviewByIdAction(dataToBeSent, setLoading)).then((apiRes) => {
        setReviewDetails(apiRes);
        if (
          apiRes?.super_admin_review &&
          apiRes?.super_admin_review !== "" &&
          apiRes?.super_admin_review !== null &&
          apiRes?.super_admin_review !== undefined
        ) {
          form.setFieldValue("message", apiRes?.super_admin_review);
        }
      });
    }
    /* initial dependencies - Edit */
  };

  /* dialog close dependencies */
  const handleDialogClose = () => {
    onClose();
    form.resetFields();
    dispatch(
      Actions.createAction(Actions.SELECTED_REVIEW_ID, { selectedReviewId: "" })
    );
    setReviewDetails(null);
  };
  /* dialog close dependencies */

  const onSubmit = (values) => {
    const dataToBeSent = {
      ...values,
      selectedReviewId,
    };
    if (
      selectedReviewId &&
      selectedReviewId !== "" &&
      selectedReviewId !== null &&
      selectedReviewId !== undefined
    ) {
      dispatch(addSuperAdminReviewAction(dataToBeSent, setLoading)).then(() => {
        handleDialogClose();
      });
    }
  };

  return (
    <Modal
      open={open}
      onCancel={handleDialogClose}
      footer={false}
      confirmLoading={loading}
      style={{ top: 20 }}
    >
      <CustomTitle textDecoration="underline" justifyContent="center">
        {t("review")}
      </CustomTitle>
      {loading ? (
        <Spinner />
      ) : (
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          onFinish={onSubmit}
          style={{ margin: "2rem" }}
        >
          <Flex gap="1rem" vertical>
            <Flex gap="1rem" align="center" justify="center">
              <Typography.Title level={3}>
                {t("reviewInfo.rating")} :{" "}
              </Typography.Title>
              <Rate disabled allowHalf value={reviewDetails?.rating} />
            </Flex>
            <Card bordered>
              <Flex gap="1rem" vertical>
                <Flex vertical gap="0.2rem">
                  <Flex gap="0.7rem">
                    <RequiredLabel text={`${t("user")}`} required={false} />
                    <div>{`${
                      reviewDetails?.user_id?.first_name &&
                      reviewDetails?.user_id?.last_name
                        ? `${reviewDetails?.user_id?.first_name} ${reviewDetails?.user_id?.last_name}`
                        : "-"
                    }`}</div>
                  </Flex>
                  <div style={{ color: colors.lightBlueGray }}>
                    {reviewDetails?.review}
                  </div>
                </Flex>
                <Flex vertical gap="0.2rem">
                  <Flex gap="0.7rem">
                    <RequiredLabel
                      text={`${t(
                        "Modules.WalletManagement.serviceProvider"
                      )} :`}
                      required={false}
                    />
                    <div>{`${reviewDetails?.organization_id?.name}`}</div>
                  </Flex>
                </Flex>
                <Form.Item
                  label={
                    <RequiredLabel
                      text={t("Modules.ReviewInfo.superAdmin")}
                      required={false}
                    />
                  }
                  name="message"
                  normalize={(value) => sanitizeDataTypeClientSide(value)}
                >
                  <TextArea
                    rows={4}
                    showCount
                    maxLength={appConstConfig.DEFAULT_CHARACTERS_ALLOWED_FOR_TEXTAREA}
                    placeholder={t("Modules.ReviewInfo.writeAReview")}
                    // disabled={reviewDetails?.super_admin_review && reviewDetails?.super_admin_review!=="" && reviewDetails?.super_admin_review!==null && reviewDetails?.super_admin_review!==undefined}
                  />
                </Form.Item>
              </Flex>
            </Card>
            <Flex gap="1rem" align="center" justify="center">
              {
                // (!reviewDetails?.super_admin_review || reviewDetails?.super_admin_review==="" || reviewDetails?.super_admin_review===null || reviewDetails?.super_admin_review===undefined) &&
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginTop: "1rem" }}
                  loading={loading}
                  disabled={loading}
                >
                  {t("CommonUtils.submit")}
                </Button>
              }
            </Flex>
          </Flex>
        </Form>
      )}
    </Modal>
  );
};

export default ReviewInfoDialog;
